import { default as React, Suspense, useEffect } from 'react';
import { Route, Switch } from 'react-router-dom';
import { compose } from 'recompose';
import NotFound from 'src/components/NotFound';
import SuspenseLoader from 'src/components/SuspenseLoader';
import {
  applicationViewPrefsContext,
  useApplicationViewPrefs,
} from 'src/features/Advisors/Dashboards/ApplicationViewPrefsContext';
import { setupNamespacePipelines } from './features/Advisors/Dashboards/dashboardTabUtils';
import { isEmpty, not } from 'ramda';
import DeedsySpinner from './components/DeedsySpinner';
import { StyledMain } from './components/main.styles';
import LogoutModal from 'src/components/Modal/LogoutModal';
import useAccounts from './hooks/useAccountsHook';
import Box from '@mui/material/Box';
import UserManageLoader from './features/Auth/Login/UserManageLoader';
import { useHistory } from 'react-router-dom';
import { LOG_OUT } from './route_constants';
import siteSetting from 'src/siteSetting';

const AdvisorLanding = React.lazy(() => import('src/features/Advisors'));
const LendsmartHome = React.lazy(
  () => import('src/features/LoansHome/LoansLanding')
);

const CoLoansLanding = React.lazy(
  () => import('src/features/LoansHome/CoLoansLanding')
);

const LoanProductLanding = React.lazy(() => import('src/features/LoansHome/LoanProductLanding'));

const MainContent: React.FC<{}> = () => {

  const contextValue = useApplicationViewPrefs();

  const ApplicationViewPrefsProvider = applicationViewPrefsContext.Provider;

  const { accountRoles } = useAccounts();

  const manageLoginTime = new UserManageLoader();

  const history = useHistory()
  
  useEffect(() => {
    /* Set the tabs for the logged in user.  The allTabPermissions contains the list of tabs supported by lendsmart and their permissions needed
    *  eg: CA Queue -> Permission is advisor_dp_tabs:visit
    *  If an user has advisor_dp_tabs:visit permission turned on then they will see that.
    */
    contextValue.setCurrentTabPref(setupNamespacePipelines());
    manageLoginTime.setInActiveTime();
  }, []);

  useEffect(() => {
    if(not(siteSetting.generalInActiveLogoutDisabled())){
      const interval = setInterval(() => {
        if (manageLoginTime.checkPageIdle(siteSetting.generalInActiveLogoutTime())) {
            history.push(LOG_OUT)
        }
      }, 1000)
      return () => {
        clearInterval(interval)
      }
    }
    return 
  });

  const handleMove = () =>{
     manageLoginTime.setInActiveTime();
  }
     

  if (isEmpty(accountRoles)) {
    return <DeedsySpinner />
  }


  return (
    <Box onMouseMove={handleMove}>
    <ApplicationViewPrefsProvider value={contextValue}>
      <StyledMain>
        <Suspense fallback={<SuspenseLoader />}>
          <Switch>
            <Route path="/loans" component={LendsmartHome} />
            <Route path="/coloans" component={CoLoansLanding} />
            <Route path="/advisors" component={AdvisorLanding} />
            <Route path="/internal" component={AdvisorLanding} />
            <Route exact path="/startnew" component={LoanProductLanding} />
            <Route component={NotFound} />
          </Switch>
        </Suspense>
        <LogoutModal />
      </StyledMain>
    </ApplicationViewPrefsProvider>
    </Box>
  );
};

export default compose(React.memo)(MainContent);
